export enum LocalStorageKeys {
  DistrictId = "districtId",
  ViewState = "viewState",
  MapFilter = "mapFilter",
  MapVisibility = "mapVisibility",
  ActiveShapes = "activeShapes",
  PlottingFilters = "plottingFilters",
  ReportsOpenTabs = "reportsOpenTabs",
  ReportsActiveTabId = "reportsActiveTabId",
  ReportsSidePanelChatId = "reportsSidePanelChatId",
  ReportsSidePanelChatTabId = "reportsSidePanelChatTabId",
  ReportsSidePanelWidth = "reportsSidePanelWidth",
  /** Last AI Assistant chat room id per district (main Chat tab, not reports side-panel). */
  AiAssistantLastChatByDistrict = "aiAssistantLastChatByDistrict",
  InteractiveLayerIds = "interactiveLayerIds",
  VisibleCustomLayerIds = "visibleCustomLayerIds",
  VisibleMapLevelIds = "visibleMapLevelIds",
  DraftLayerPins = "draftLayerPins",
  CustomLayerEditSession = "customLayerEditSession",
  DistrictBoundaryUploadSession = "districtBoundaryUploadSession",
  CustomLayersUploadSession = "customLayersUploadSession",
  AttendanceZonesUploadSession = "attendanceZonesUploadSession",
  MapStyle = "mapStyle",
  MapActivePresetId = "mapActivePresetId",
  MapDefaultViewByDistrict = "mapDefaultViewByDistrict",
  MapDrawHintsCadence = "mapDrawHintsCadence",
  MyDistrictListFilters = "myDistrictListFilters",
  DriveFilters = "driveFilters",
}
